// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_do-0";
export var actionModalContentContainer = "_do-1";
export var createTagButton = "_do-2";
export var footerContainer = "_do-7";
export var fullWidthDivider = "_do-3";
export var hasCreateTagButton = "_do-4";
export var noCreateTagButton = "_do-5";
export var tagsContainer = "_do-6";
export var tagsModalContentContainer = "_do-8";